module.exports = __webpack_public_path__ + "img/Icon_Espacios_Disponibles_Hover.e2dbd95f.svg";